
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[campaign]/spot",
      function () {
        return require("private-next-pages/[campaign]/spot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[campaign]/spot"])
      });
    }
  